import React from 'react';

export const Spei = ({cliente, handleGenerarFicha, btnLoading}) => {
    return (
        <div>
            <p className="text-warning">Está forma de pago genera una comisión bancaria de $10 MXN por el procesamiento de este tipo de transacción.</p>
            <div className="row">
                <div className="col-md-12 text-center">
                    <h6>Total con comisión:</h6>
                    <h5 className="text-success">
                        { new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(parseFloat(cliente.anticipo)+10) }
                    </h5>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col mt-2 d-flex align-content-center justify-content-center">
                    <button 
                        className="btn btn-primary" 
                        type="submit"
                        disabled={btnLoading}
                        onClick={() => handleGenerarFicha('bank_account')}
                    >
                        {btnLoading && <i className="spinner-border spinner-border-sm" role="status"></i>} Generar ficha de pago
                    </button>
                </div>
            </div>
        </div>
    )
}
